import React from 'react';

interface ProofreadHeaderControlsProps {
  matterId?: string;
  workspaceId?: string;
  documentId?: string;
}

export const ProofreadHeaderControls: React.FC<
  ProofreadHeaderControlsProps
> = ({ matterId, workspaceId, documentId }) => {
  if (!matterId || !workspaceId || !documentId) {
    return (
      <div className="flex items-center text-gray-500 text-sm pl-2">
        Proofreading tools - requires workspace setup
      </div>
    );
  }

  return <div className="flex items-center space-x-2 pl-2" />;
};
